export default async function ({ store, from, route }) {
  const id = route.params.id;

  if (store.state.products.list.length == 0 && !from && id) {
    //TODO: add this later on await store.dispatch('posts/loadSinglePost', id);
  } else {
    await store.dispatch('products/load');
  }
}
